import React from 'react';

const Salvation = () => (
  <section
    id="salvation"
    className="g-pt-75 g-pb-45"
    style={{
      backgroundImage: "url('/images/bg_1.jpeg')",
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
    }}
  >
    {/* A light overlay so text is readable */}
    <div
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        paddingTop: '3rem',
        paddingBottom: '3rem',
      }}
    >
      <div className="container">
        <div className="row">
          {/* Text / Scriptures */}
          <div className="col-lg-6 order-2 order-sm-1 g-mb-30">
            <div className="u-heading-v2-3--bottom g-brd-primary g-mt-minus-10 g-mb-10">
              <h2 className="h4 u-heading-v2__title g-color-gray-dark-v2 g-font-weight-600 text-uppercase">
                Jesus Christ as Your Savior
              </h2>
            </div>

            <div className="g-font-size-16 g-line-height-2 g-mb-10">
              <p>
                Scripture teaches that every person has sinned and stands in need of
                God&apos;s grace and forgiveness.
              </p>

              <p>
                <strong>Romans 3:23:</strong> &quot;For all have sinned and fall short
                of the glory of God.&quot;
              </p>
              <p>
                <strong>1 John 3:4:</strong> &quot;Everyone who makes a practice of
                sinning also practices lawlessness; sin is lawlessness.&quot;
              </p>
              <p>
                <strong>Romans 6:23:</strong> &quot;For the wages of sin is death, but
                the free gift of God is eternal life in Christ Jesus our Lord.&quot;
              </p>
              <p>
                <strong>Hebrews 9:27:</strong> &quot;And just as it is appointed for
                man to die once, and after that comes judgment.&quot;
              </p>

              <p>
                The good news is that God has provided a way of salvation through His
                Son, Jesus Christ.
              </p>

              <p>
                <strong>John 3:16:</strong> &quot;For God so loved the world, that he
                gave his only Son, that whoever believes in him should not perish but
                have eternal life.&quot;
              </p>
              <p>
                <strong>Romans 5:8:</strong> &quot;But God shows his love for us in
                that while we were still sinners, Christ died for us.&quot;
              </p>
              <p>
                <strong>1 Corinthians 15:3–4:</strong> &quot;…that Christ died for our
                sins in accordance with the Scriptures, that he was buried, that he
                was raised on the third day in accordance with the Scriptures.&quot;
              </p>

              <p className="g-mt-20">
                Salvation is God&apos;s gift. We receive it by turning from sin and
                trusting in Jesus Christ alone as Lord and Savior.
              </p>

              <p className="g-font-size-14 g-mb-0">
                If you desire to receive Christ today, you can pray from your heart,
                acknowledging your sin, believing that Jesus died and rose again for
                you, and asking Him to be Lord of your life. God hears the sincere cry
                of a repentant heart.
              </p>
            </div>
          </div>

          {/* Video */}
          <div className="col-lg-6 order-1 order-sm-2 align-self-center text-center g-pos-rel g-mb-30">
            <video
              controls
              width="100%"
              poster="/path/to/thumbnail.jpg"
              className="g-mb-10 rounded"
            >
              <source src="/videos/video.mp4" type="video/mp4" />
              <source src="/videos/video.webm" type="video/webm" />
              <source src="/videos/video.ogv" type="video/ogg" />
              {/* Fallback message */}
              Your browser doesn&apos;t support HTML5 video. Please{' '}
              <a href="/videos/video.mp4">download the MP4</a> to watch.
            </video>
            <p className="g-color-gray-dark-v5 g-mb-0">
              Watch our short message on salvation.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Salvation;
